import { Component, defineComponent } from '@decify/cell-shopify/client';
import { buttonClickEvent, buttonName } from '../Button';
import { overlayClickEvent, overlayName } from '../Overlay';
import { productListActionClickEvent, productListActionName } from '../ProductList';
import './Drawer.scss';
export const drawerName = 'Drawer';
export const drawerTagName = 'cell-component-drawer';
export class Drawer extends Component {
    active;
    constructor() {
        super(drawerName);
        this.active = false;
        this.toggle = this.toggle.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }
    componentDidMount() {
        globalThis.subscribe(`${buttonName}[toggle-${this.props.id}].${buttonClickEvent}`, this.toggle);
        globalThis.subscribe(`${productListActionName}[toggle-${this.props.id}].${productListActionClickEvent}`, this.toggle);
        this.subscribe(`${buttonName}[close].${buttonClickEvent}`, this.close);
        this.subscribe(`${overlayName}.${overlayClickEvent}`, this.close);
    }
    toggle() {
        if (this.active) {
            this.close();
        }
        else {
            this.open();
        }
    }
    open() {
        this.active = true;
        this.classList.add('Drawer--Active');
        setTimeout(() => {
            this.classList.add('Drawer--Visible');
        }, 10);
    }
    close() {
        this.active = false;
        this.classList.remove('Drawer--Visible');
        setTimeout(() => {
            this.classList.remove('Drawer--Active');
            // The time needed to finish cart drawer inner animation.
        }, 450);
    }
}
defineComponent(drawerTagName, Drawer);
